<template>
    <div>
        <!-- 筛选 -->
        <my-search timeScreen :inputArr="inputArr" :selectArr="selectArr" :searchParams="searchParams" :[dynamicData]="2" @searchEvent="searchEvent" @addEvent="addEvent" @allDel="allDel" @allExport="allExport" @allImportTemplate="allImportTemplate" />

        <!--列表-->
        <my-table isSelection :loading="loading" :tableData="tableData" :tableHeader="tableHeader" :pageParams="pageParams" @click.native="testNative" @handleSelectionChange="handleSelectionChange">
            <template v-slot:table_after>
                <el-table-column label="所属分类" align="center">
                    <template slot-scope="{ row }">
                        <el-tooltip class="item" effect="dark" placement="right" v-if="row.docNavigationList[1]">
                            <div slot="content" class="content">
                                <p v-for="(item, index) in row.docNavigationList" :key="index">
                                    {{ item}}
                                </p>
                            </div>
                            <span>
                                {{ item[0] + "..." }}
                            </span>
                        </el-tooltip>
                        <span v-else> {{ row.docNavigationList[0]?row.docNavigationList[0]:'暂无分类' }}</span>
                    </template></el-table-column>
                <el-table-column label="操作" min-width="200px" align="center">
                    <template slot-scope="{ row }">
                        <el-button type="text" size="mini" @click="detailArtice(row)">详情</el-button>
                        <el-button type="text" size="mini" @click="editArtice(row)">编辑</el-button>
                        <el-button type="text" size="mini" @click="delArtice(row)">删除</el-button>
                    </template>
                </el-table-column>
            </template>
        </my-table>

        <!-- 分页组件 -->
        <my-pagination :childMsg="pageParams" @callFather="callFather" />

        <!-- 添加、修改组件 -->
        <my-dialog :isDialogShow.sync="isDialogShow" :operTitle="operTitle" :operForm="operForm" :operFormArr="operFormArr" :rules="rules" :loading="loading" @submitForm="submitForm" @hook:mounted="doSomeThing" :selectArrAdd="selectArrAdd"/>

        <!-- 详情组件 -->
        <my-dialog-detail :isDialogDetailShow.sync="isDialogDetailShow" :operForm="operForm" :operFormArr="operFormArr" :closeDialog="closeDialog" />
        <!-- 详情对话框 -->
        <el-dialog title="文章内容" :visible.sync="dialogVisible" width="30vw">
            <div class="articalContent" v-html="transHtml" v-loading="loading2"></div>
        </el-dialog>
    </div>
</template>

<script>
import _exportMethods from "@/utils/excel";
import mixins from "@/mixins/common";
import {
    articeList,
    addArtice,
    editArtice,
    delArtice,
    allDelArtice,
    docRecall,
	articeDetails
} from "@/network/content/artice";

export default {
    mixins: [mixins],
    provide() {
        return {
            importType: "artice",
            initData: this.getInitData,
        };
    },
    watch: {
        tableData: {
            handler(val) {
                // console.log(val);
            },
            immediate: false,
            deep: false,
        },
    },
    data() {
        return {
            dialogVisible: false, //详情对话框
            loading2: false, //内容
            transHtml: "", //详情html内容
            /**
             * 当前头部数据列
             * 不需要响应式的数据可以进行冻结，Vue实例不会对数据再做数据劫持(getter、setter转换),可以提高Vue渲染性能
             * 不可以向当前对象添加、更新、删除属性。如需修改可以将变量的引用替换掉
             */
            tableHeader: [
                {
                    name: "文档名称",
                    prop: "docTitle",
                    width: "150px",
                },
                {
                    name: "标签",
                    prop: "docTags",
                    width: "150px",
                },
                {
                    name: "来源单位",
                    prop: "createUnit",
                },
                {
                    name: "文档简介",
                    prop: "docIntroduction",
                },
                // {
                //     name: "文章类型",
                //     prop: "docNavigationList",
                //     formatData(val) {
                //         let value = val.reduce((pre, cur) => {
                //             cur = cur + pre;
                //             return cur;
                //         }, "");
                //         return value;
                //     },
                // },
                {
                    name: "发布状态",
                    prop: "isRelease",
                },
                {
                    name: "发布时间",
                    prop: "startTime",
                },
                {
                    name: "收藏数",
                    prop: "docCollectionCount",
                },
                {
                    name: "转发数",
                    prop: "docShareCount",
                },
                {
                    name: "浏览数",
                    prop: "docGlanceOverCount",
                },
                //  {
                //     name: "归属频道",
                //     prop: "docGlanceOverCount",
                // },
                // {
                //     name: "文章分类",
                //     prop: "docNavigationList",
                // },
                // {
                //     name: "操作",
                //     prop: "operation",
                //     // width: "180",
                //     operation: [
                //         // { name: "发布", clickFun: this.releaseArtice, show: true },
                //         {
                //             name: "详情",
                //             clickFun: this.detailArtice,
                //             show: true,
                //         },
                //         { name: "编辑", clickFun: this.editArtice, show: true },
                //         { name: "删除", clickFun: this.delArtice, show: true },
                //     ],
                // },
                // 
            ],
            //筛选时文本框所需参数
            inputArr: [
                {
                    name: "userZh",
                    defaultText: "请输入文档名称",
                },
            ],
            selectArr: [
                {
                    defaultText: "请选择文章状态",
                    name: "isRelease",
                    getData: "value",
                    defaultOptions: [
                        //0  发布  2未审核  3下架
                        { label: "发布", value: 0 },
                        { label: "未审核", value: 2 },
                        { label: "下架", value: 3 },
                    ],
                },
                {
                    defaultText: "请选择收费类型",
                    name: "isFree", //这个字段后续和后端对应上目前由前端自定义
                    getData: "label",
                    defaultOptions: [
                        { label: "会员免费" },
                        { label: "会员折扣" },
                        { label: "免费" },
                    ],
                },
            ],
            //添加、编辑时文本框所需参数
            operFormArr: [
                {
                    name: "docTitle",
                    label: "文档名称",
                    defaultText: "请输入文档名称",
                },
                {
                    name: "docTags",
                    label: "标签",
                    defaultText: "请输入标签",
                },
                {
                    name: "createUnit",
                    label: "来源单位",
                    defaultText: "请输入来源单位",
                },
                {
                    name: "docIntroduction",
                    label: "文档简介",
                    type: "textarea",
                    defaultText: "请输入文档简介",
                },
            ],
            //添加、编辑双向绑定值
            operForm: {
                id: "",
                docTitle: "",
                docTags: "",
                createUnit: "",
                docCollectionCount: "",
				docVip:""
            },
			selectArrAdd:[
				{
					prop: "docVip",
				    label: "收费模式",
				    getData: "value",
				    defaultOptions: [
				        { label: "免费", value: "1" },
				        { label: "会员", value: "2" },
				        { label: "隐藏模式", value: "3" },
				    ],
				},
			],
            //搜索参数
            searchParams: {
                timeOptions: "",
                userZh: "", //Sophos收购了Braintrace 将Python远控隐藏在文档图片中的行动分析
                isRelease: "",
            },
            // rules表单验证
            rules: {
                docTitle: [
                    {
                        required: true,
                        message: "请输入文档名称",
                        trigger: "blur",
                    },
                ],
				docShareCount: [
				    {
				        required: true,
				        message: "请选择收费模式",
				        trigger: "blur",
				    },
				],
            },
        };
    },
    mounted() {
        // console.log(this.$route.query.isRelease);
        //发布成功
        // if(this.$route.query.isRelease) {
        //     this.tableHeader[6].operation[0].show = false
        //     this.tableHeader[6].operation[1].show = true
        // }
    },
    methods: {
        getInitData(isSearch) {
            let timeOptions = this.searchParams.timeOptions; //日期参数
            let params = {
                docTitle: this.searchParams.userZh,
                isRelease: this.searchParams.isRelease,
                startTime: timeOptions ? timeOptions[0] : "",
                endTime: timeOptions ? timeOptions[1] : "",
                current: isSearch ? 1 : this.pageParams.currentPage,
                size: this.pageParams.pageSize,
            };
            articeList(params).then((e) => {
                this.loading = false;
                let { code, data, msg } = e.data;
                if (code == 200) {
                    this.tableData = data.records;
                    this.pageParams.total = data.total;
                    if (isSearch) this.pageParams.currentPage = 1;
                }
            });
        },
        //添加、编辑
        submitForm(valid) {
            if (valid) {
                //根据类型不同调用不同的操作接口
                let interType = this.operTitle ? addArtice : editArtice;
                interType(this.operForm).then((e) => {
                    let { code, data, msg } = e.data;
                    if (code == 200) {
                        this.isDialogShow = false;
                        this.loading = false;
                        this.getInitData();
                        this.$message.success("操作成功");
                    } else {
                        this.$message.error("操作失败");
                    }
                });
            } else {
                return false;
            }
        },
        //搜索事件
        searchEvent() {
            this.getInitData(true);
        },
        //添加事件
        addEvent() {
            this.isDialogShow = true;
            this.operTitle = true;
            this.operForm = {}; //防止多次添加有上次添加的残留数据
        },
        //发布文章
        releaseArtice(item) {
            this.$router.push({
                path: "/edit",
                query: {
                    item: JSON.stringify(item),
                },
            });
        },
        //撤回文章
        withdrawArtice(item) { },
        //详情事件
        detailArtice(item) {
            // this.isDialogDetailShow = true;
            // this.operForm = item;
            //展示文章详情

            //点击详情
            this.loading2 = true;
            this.dialogVisible = true;
            this.transHtml = "";
            articeDetails({
                docId: item.id,
            })
                .then((res) => {
                    if (res.data.code == 200) {
                        var data = res.data.data;
                        this.transHtml = data.transHtml;
                    }
                    this.loading2 = false;
                })
                .catch((err) => { });
        },
        //编辑事件
        editArtice(item) {
            this.isDialogShow = true;
            this.operTitle = false;
            this.operForm = {
                id: item.id,
                docTitle: item.docTitle,
                docTags: item.docTags,
                createUnit: item.createUnit,
                docIntroduction: item.docIntroduction,
				docVip:item.docVip,
            };
        },
        //删除事件
        delArtice(item) {
            this.$confirm("删除该条数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                delArtice(item.id).then((e) => {
                    let { code, data, msg } = e.data;
                    if (code == 200) {
                        this.getInitData();
                        this.$message.success("操作成功");
                    } else {
                        this.$message.error("操作失败");
                    }
                });
            });
        },
        //批量删除
        allDel() {
            let data = this.selectedData;
            if (data.length == 0) {
                this.$message.warning("请选择要操作的数据！");
                return;
            }
            this.$confirm("删除所选数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let delIds = [];
                delIds = data.map((e) => e.id);
                allDelArtice({
                    ids: delIds,
                }).then((e) => {
                    let { code, data, msg } = e.data;
                    if (code == 200) {
                        this.getInitData();
                        this.$message.success("操作成功");
                    } else {
                        this.$message.error("操作失败");
                    }
                });
            });
        },
        //批量导出
        allExport() {
            let timeOptions = this.searchParams.timeOptions; //日期参数
            let data = {
                data: {
                    docTitle: this.searchParams.textDocTitle,
                },
                startTime: timeOptions ? timeOptions[0] : "",
                endTime: timeOptions ? timeOptions[1] : "",
                current: this.pageParams.currentPage,
                size: this.pageParams.pageSize,
            };
            let exportParams = {
                method: "post",
                url: "/api/app/sys/doc/export/list",
                data,
            };
            _exportMethods(exportParams);
        },
        //导入模板
        allImportTemplate() {
            let importParams = {
                method: "get",
                url: "/api/app/sys/doc/export/template",
            };
            _exportMethods(importParams);
        },
        //详情函数式组件关闭弹框
        closeDialog() {
            this.isDialogDetailShow = false;
        },
        //在子组件上监听点击事件，如果不加.native的话，Vue会以为是自定义的事件，这样的话必须得在子组件发送一个emit事件触发才可以
        testNative() {
            // console.log("native click");
        },
        //在父组件里监听到子组件的生命周期 @hook:mounted="doSomething"
        doSomeThing() {
            // console.log('父组件监听到 mounted 钩子函数 ...');
        },
    },
};
</script>

<style scoped>
.articalContent {
    width: 100%;
    height: 60vh;
    overflow: auto;
}
</style>

 
 